<div class="tab-box">
  <div class="acciones-tabla">
    <app-input-tabla (keyup)="applyFilter($event)"></app-input-tabla>
    <div>
      <app-nueva-entidad (click)="openDialog()"></app-nueva-entidad>
      <app-descargar (click)="exportAsExcel()"></app-descargar>
    </div>
  </div>
  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
    <ng-container matColumnDef="id">
      <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
        ID
      </th>
      <td mat-cell *matCellDef="let usuario" (click)="openDetails(usuario.id)">
        {{ usuario.id }}
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>NOMBRE</th>
      <td mat-cell *matCellDef="let usuario">{{ usuario.name }}</td>
    </ng-container>
    <ng-container matColumnDef="username">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>USUARIO</th>
      <td mat-cell *matCellDef="let usuario">{{ usuario.username }}</td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>MAIL</th>
      <td mat-cell *matCellDef="let usuario">
        {{ usuario.email }}
      </td>
    </ng-container>
    <ng-container matColumnDef="jefe">
      <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
        CLIENTE/ CONTRATISTA
      </th>
      <td mat-cell *matCellDef="let usuario">
        <div *ngIf="usuario.contratista">
         Contratista: {{ usuario.contratista?.nombreComercial }}
        </div>
        <div *ngIf="usuario.cliente">
          Cliente: {{ usuario.cliente?.nombreComercial }}
        </div>
        <div *ngIf="usuario.inproeco">
          Inproeco
        </div>
        <ng-template #elseBlock>-</ng-template>
      </td>
    </ng-container>

    <!-- <ng-container matColumnDef="indicadores">
      <th mat-header-cell *matHeaderCellDef>INDICADORES</th>
      <td mat-cell *matCellDef="let usuario">
        <img src="../../../../../assets/group-peque.png" />
      </td>
    </ng-container> -->
    <ng-container matColumnDef="acciones">
      <th mat-header-cell *matHeaderCellDef>ACCIONES</th>
      <td mat-cell *matCellDef="let usuario">
       <!--  <img
          class="tabla-editar"
          (click)="openDetails(usuario.id)"
          src="../../../../../assets/lapiz.png"
        /> -->
        <img
          class="tabla-borrar"
          (click)="handleClick(usuario.id)"
          src="../../../../../assets/trash.png"
        />
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 15, 20]"></mat-paginator>
</div>
